import { c as _c } from "react/compiler-runtime";
export type StarIconProps = {
  filled?: boolean;
};
export function StarIcon(t0) {
  const $ = _c(5);
  const {
    filled: t1
  } = t0;
  const filled = t1 === undefined ? true : t1;
  const t2 = `star-icon${filled ? "-filled" : ""}`;
  const t3 = filled ? "currentColor" : "none";
  let t4;
  if ($[0] !== t3) {
    t4 = <path d="M12.4664 19.2917L12.2785 19.1784L12.0905 19.2917L5.41237 23.3224L7.18458 15.7257L7.23444 15.512L7.06855 15.3682L1.16797 10.2565L8.93722 9.59741L9.15569 9.57887L9.24129 9.37697L12.2785 2.21094L15.3156 9.37697L15.4012 9.57887L15.6197 9.59741L23.3889 10.2565L17.4883 15.3682L17.3225 15.512L17.3723 15.7257L19.1446 23.3224L12.4664 19.2917Z" fill={t3} stroke="currentColor" strokeWidth="1" />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2 || $[3] !== t4) {
    t5 = <svg width="1em" height="1em" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={t2}>{t4}</svg>;
    $[2] = t2;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}